export default {
  405: {
    title: 'Conta e Pesquisa no encontradas',
    body: 'Verifique se a conta e pesquisa estão corretas.',
    return: 'Volver',
  },
  406: {
    title: 'Dashboard no encontrado',
    body: 'Verifique seu acceso com o administrador do dashboard.',
    return: 'Volver',
  },
  404: {
    title: 'Pagina no encontrada',
    body: 'Essa pagina no existe. Verifique o link de acceso antes de continuar.',
    return: 'Volver',
  },
  403: {
    title: 'Acceso no permitido',
    body: 'Você no tem a permiso necessária para acceder essa pagina.',
    return: 'Volver',
  },
  500: {
    title: 'Error de Comunicação',
    body: 'A pagina demorou muito para responder. Atualize ou tente novamente.',
    return: 'Volver',
  },
  noPermission: 'Você no possui permiso para realizar esta ação.',
};
